/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@sc/App/Libraries";
import "@sc/App/Store/Reducers";
import "@sc/XDL";

// load all widgets. Without this they won't be included in the bundle
const widgets = require.context("./App/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(String(widgets.id), () => onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)));
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(String(pages.id), () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// load all handlers. They could be loaded individually instead.
const handlers = require.context("./App/Handlers", true); // Recursively get all handler modifications
handlers.keys().forEach(key => handlers(key)); // Load the handler modifications.

// load all widget extensions. They could be loaded individually instead
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// Load all the extensions to the base pages. This includes style extensions.
const pagesExtensions = require.context("./App/PagesExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));

// load all widget extensions. They could be loaded individually instead
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

// load all widgets. Without this they won't be included in the bundle
const GoogleAnalyticsWidgets = require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onGoogleAnalyticsHotWidgetReplace = addWidgetsFromContext(GoogleAnalyticsWidgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(GoogleAnalyticsWidgets.id.toString(), () =>
        onGoogleAnalyticsHotWidgetReplace(require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/)),
    );
}

const googleAnalyticsHandlers = require.context("./App/GoogleAnalyticsConnector/Handlers", true);
googleAnalyticsHandlers.keys().forEach(key => googleAnalyticsHandlers(key));
/**
 * End Google Analytics Integration
 */
